import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor() {
        super();

        this.setState({ pm: false });
    }

    render({ group_label }) {
        return (
            <time-select>
                <legend>{group_label}</legend>
                {this.renderTimeInput()}
                <input
                  type='checkbox'
                  data-action='Select-Birth-Time-Unknown'
                  data-category={this.props.ga_category}
                  data-ga-event
                  data-label={this.props.upc}
                  name='dontknow'
                />
                <label htmlFor='dontknow'>
                    Birth time unknown
                    <span class='detail'>(this is used to calculate rising and moon signs)</span>
                </label>
            </time-select>
        );
    }

    renderTimeInput = () => {
        if (window.Modernizr.inputtypes.time) {
            <input
              type='time'
              class='js-autofill-user-birth-time'
              data-action='Input-Birth-Time'
              data-category={this.props.ga_category}
              data-ga-event
              data-label={this.props.upc}
              name='birth_time'
              value='12:00'
            />;
        }

        return (
            <fieldset>
                <select
                  class='js-autofill-user-birth-hour'
                  data-action='Select-Birth-Hour'
                  data-category={this.props.ga_category}
                  data-ga-event
                  data-label={this.props.upc}
                >
                    <option selected disabled>Hour</option>
                    {_.range(1, 13).map(hour => ( <option value={hour}>{hour}</option> ))}
                </select>
                <select
                  class='js-autofill-user-birth-minute'
                  data-action='Select-Birth-Minute'
                  data-category={this.props.ga_category}
                  data-ga-event
                  data-label={this.props.upc}
                >
                    <option selected disabled>Minute</option>
                    {_.range(60).map(minute => ( <option value={minute}>{minute}</option> ))}
                </select>
                <button onClick={this.toggle} class={this.state.pm ? '' : 'active'} data-value='am'>AM</button>
                <button onClick={this.toggle} class={this.state.pm ? 'active' : ''} data-value='pm'>PM</button>
            </fieldset>
        );
    }

    toggle = () => {
        this.setState({ pm: !this.state.pm });
    }
}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/fields/time.js